<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	height: '2',
}
const schema = defineSchema({
	height: $.text('Height (rem)'),
})
export const BlockSpace = defineBlock({ thumbnail: '/block-thumbs/BlockSpace.svg', category: 'Layout', order: 270, name: 'BlockSpace', label: 'Spacer', icon: 'height', schema, defaults })
</script>
<script setup lang="ts">


import { computed } from 'vue'




const props = defineProps<{
	height?: string
}>()

const spaceStyle = computed(() => {
	const value = Number.parseFloat(props.height ?? '2')
	const absValue = Math.abs(value)

	if (value >= 0) {
		return { height: `${absValue}rem` }
	} else {
		return { marginBottom: `-${absValue}rem` }
	}
})
</script>

<template>
	<div :style="spaceStyle" />
</template>
